import { lmsApi } from "@/utils/axios-config";

export default {
    getConfig() {
        return lmsApi.get(`/config`);
    }
};
